import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import MatchDots from "../../components/ExcerciseTypes/LineTo/MatchDots";

const json = {
  3: {
    // Exercise num
    unit: "Unit 3",
    id: "FGF11-U3-P45-E2",
    audio: "",
    video: "",
    component: MatchDots,
    // hideBtnFooter: true,
    exerciseKey: "/img/FriendsPlus/Page32/Key/E3answerKey.png",
    titleQuestion: [
      {
        num: "3",
        title: `
          
          `,
        color: "rgb(99,197,244)",
      },
    ],

    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        Nối điểm O với điểm P (câu a) hoặc điểm Q (câu b) đúng theo đề bài.<br>
        <b>Cách nối một đoạn thẳng:</b> Nháy chuột vào chấm đen tại điểm O và chấm đen tại điểm P thích hợp (câu a), điểm Q thích hợp (câu b) để tạo thành một đoạn thẳng.<br>
        <b>Để xóa một đoạn thẳng:</b> Nháy chuột lần nữa vào chấm đen tại điểm O và chấm đen tại điểm P (câu a), điểm Q (câu b) để xóa đoạn thẳng.<br>
        <video src="Audios/bt_fpt_ai/guide/p32_e3.mp3" controls style="width: 100%; height: 2cm"></video>     
        
        `,
      },
    ],
    stylesTextInput: { borderBottom: "10px dashed", textAlign: "center" },
    inputSize: 50,
    question: {
      DrawLines: {
        multipleLine: true,
        boxMatch: [
          {
            boxMatchStyle: {
              position: "absolute",
              top: "252px",
              left: "613px",
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              border: 0,
              background: "black ",
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "90px",
              left: "569px",
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              border: 0,
              background: "black",
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "90px",
              left: "682px",
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              border: 0,
              background: "black",
            },
          }, // 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "171px",
              left: "804px",
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              border: 0,
              background: "black",
            },
          }, // 4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "252px",
              left: "807px",
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              border: 0,
              background: "black",
            },
          }, // 5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "176px",
              left: "366px",
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              border: 0,
              background: "black",
            },
          },
          // 6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "540px",
              left: "613px",
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              border: 0,
              background: "black",
            },
          },
          // 7
          {
            boxMatchStyle: {
              position: "absolute",
              top: "396px",
              left: "613px",
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              border: 0,
              background: "black",
            },
          },
          // 8
          {
            boxMatchStyle: {
              position: "absolute",
              top: "396px",
              left: "697px",
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              border: 0,
              background: "black",
            },
          },
          // 9
          {
            boxMatchStyle: {
              position: "absolute",
              top: "431px",
              left: "807px",
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              border: 0,
              background: "black",
            },
          },
          // 10
          {
            boxMatchStyle: {
              position: "absolute",
              top: "517px",
              left: "807px",
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              border: 0,
              background: "black",
            },
          },
          // 11
          {
            boxMatchStyle: {
              position: "absolute",
              top: "465px",
              left: "346px",
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              border: 0,
              background: "black",
            },
          },
          // 12
        ],
        answers: ["0-2", "11-6"],
        initialValue: [],
      },
      Layout: `
            <h2  style="font-weight: bold;">a) Vẽ thêm đoạn thẳng OP để đoạn thẳng OP tạo với đoạn thẳng OA một góc tù, đồng thời tạo với đoạn thẳng OB một góc nhọn.
            </h2>

            <img src="img/FriendsPlus/Page32/6.png" alt="images" style="margin-left: 300px;margin-top: 20px;z-index: 10;" width="350px">



            <div style= "position: relative; font-weight: bold; top: -225px; left: 564px; color: black; font-size: 22px">P</div>
            <div style= "position: relative; font-weight: bold; top: -257px; left: 677px; color: black; font-size: 22px">P</div>
            <div style= "position: relative; font-weight: bold; top: -211px; left: 798px; color: black; font-size: 22px">P</div>
            <div style= "position: relative; font-weight: bold; top: -143px; left: 822px; color: black; font-size: 22px">P</div>
            <div style= "position: relative; font-weight: bold; top: -253px; left: 331px; color: black; font-size: 22px">P</div>
            
            
            <input id='0' type= 'boxMatch' />
            <input id='1' type= 'boxMatch' />
            <input id='2' type= 'boxMatch' />
            <input id='3' type= 'boxMatch' />
            <input id='4' type= 'boxMatch' />
            <input id='5' type= 'boxMatch' />
           

            <h2  style="font-weight: bold;;margin-top: -150px;">b) Vẽ thêm đoạn thẳng OQ để đoạn thẳng OQ tạo với mỗi đoạn thẳng OA và OB một góc nhọn
            </h2>

            <img src="img/FriendsPlus/Page32/6.png" alt="images" style="margin-left: 300px;margin-top: 40px;z-index: 10;" width="350px">

            <div style= "position: relative; font-weight: bold; top: -214px; left: 604px; color: black; font-size: 22px">Q</div>
            <div style= "position: relative; font-weight: bold; top: -247px; left: 689px; color: black; font-size: 22px">Q</div>
            <div style= "position: relative; font-weight: bold; top: -223px; left: 821px; color: black; font-size: 22px">Q</div>
            <div style= "position: relative; font-weight: bold; top: -169px; left: 821px; color: black; font-size: 22px">Q</div>
            <div style= "position: relative; font-weight: bold; top: -254px; left: 311px; color: black; font-size: 22px">Q</div>

            <input id='6' type= 'boxMatch' />
            <input id='7' type= 'boxMatch' />
            <input id='8' type= 'boxMatch' />
            <input id='9' type= 'boxMatch' />
            <input id='10' type= 'boxMatch' />
            <input id='11' type= 'boxMatch' />



            
            
        `,
    },
  },
  4: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    // audio: "Audios/bt_fpt_ai/p24_intro.mp3",
    // autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page32/Key/E4answerKey.png",
    component: T6,
    isHiddenCheck: true,
    // hideBtnFooter:true,
    maxLength: 2,
    stylesTextInput: {
      borderBottom: "3px dotted black",
      textAlign: "center",
      background: "none",
      fontSize: 24,
      textTransform: "uppercase",
    },
    inputSize: 100,
    titleQuestion: [
      {
        num: "4",
        title: `Viết số thích hợp vào chỗ chấm.
		    `,
        color: "rgb(99,197,244)",
      },
    ],

    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>
          Đếm số góc có trong hình và và điền vào chỗ chấm.
        </span>
        <video src="Audios/bt_fpt_ai/guide/p32_e4.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='position: relative; line-height: 50px'>
        <div>Quan sát các bước hướng dẫn gấp một tờ giấy hình vuông như hình dưới đây.</div>
          <img src='/img/FriendsPlus/Page32/E4/1.jpg' style='height:10cm; width: 18cm; margin-bottom: 30px'/><br>
        
        	<div style=''>Sau bước thứ năm, hình thu được có <input id= "0"> góc vuông và <input id= "1"> góc tù ở các đỉnh. </div>
        
        </div>
        `,
        answer: ["7", "4"],
      },
    ],
  },
  5: {
    unit: "Review 2",
    id: "4WB-R2-P49-E5",
    audio: "",
    video: "",
    exerciseKey: "img/FriendsPlus/Page32/Key/E5answerKey.png",
    component: Circle_Write,
    // checkUppercase: true,
    isHiddenCheck: true,
    titleQuestion: [
      {
        num: "5",
        title: `
      			Khoanh vào chữ đặt trước câu trả lời đúng.
      		  `,
        color: "rgb(99,197,244)",
      },
    ],

    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>
          Nháy chuột vào chữ đặt trước câu trả lời đúng.
        </span>
        <video src="Audios/bt_fpt_ai/guide/p32_e5.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    question: {
      Write: {
        isHiddenCheck: true,
        maxLength: 10,
        inputStyle: {
          width: 250,
          fontSize: 24,
          textAlign: "center",
          height: 29,
          paddingBottom: 10,
          textTransform: "uppercase",
        },
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          padding: 5,
          // borderColor: "transparent",
          fontWeight: 700,
          color: "rgb(88,147,198)",
        },
        // initialWordStyle: { fontWeight: 'bold', border: 'none', borderRadius: '50%', borderColor: 'transparent' },
        selectWordStyle: {
          padding: 5,
          border: "2px solid black",
          borderRadius: "50%",
          // borderColor: "",
        },
        limitSelect: 1,
        listWords: [`A <br> B <br> C <br> D`],
        answers: ["0-12"],
        initialValue: [],
      },
      Layout: `
      <div style='position: relative; line-height: 46px'>
        <div>Hai bạn đứng dựa lưng vào nhau rồi mỗi bạn đi thẳng về phía trước. Đường đi của mỗi bạn tạo ra một đoạn thẳng. Góc tạo bởi hai đoạn thẳng đó là góc gì?
        </div>
        <div style='display: flex; gap: 15px;'>
                <div><input id='0' type='Circle' /></div>
                <div>
                  <div>Góc nhọn</div>
                  <div>Góc vuông</div>
                  <div>Góc tù</div>
                  <div>Góc bẹt</div>
                  
                </div>

        
	    </div>
      `,
    },
  },
};

export default json;
